import type { IHolidaySearchQueryParams } from "@/feature/holiday/search/types/holiday-search-type";

export function formatHolidayDestination(
  searchData: IHolidaySearchQueryParams | null,
) {
  if (!searchData?.city) {
    return "All destinations";
  }

  const country = searchData.country ? `, ${searchData.country}` : "";

  return `${searchData.city}${country}`;
}
